import React from "react";

function Output({ data }) {
  return (
    <div className="output section">
      <h2 className="otherhead">Output</h2>
      <div className="panel output-panel">
        {data && data.err ? (
          <div style={{ backgroundColor: "red", color: "white", padding: "10px", borderRadius: "5px" }}>
            <p>Error:</p>
            <pre>{data.err}</pre>
          </div>
        ) : data ? (
          <pre>{data.out}</pre>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}

export default Output;
